import { Color24, Colors24 } from '@grammarly/badger-ui'

interface WebinarProps {
  color?: Color24
}

export const ResourceIcon = (props: WebinarProps) => {
  const { color = 'green60' } = props
  const strokeColor = Colors24[color]
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.68495 7.75787L2.83841 8.79172C2.3872 9.04435 2.3872 9.67592 2.83841 9.92855L10.4662 14.1992C10.885 14.4337 11.401 14.4337 11.8199 14.1992L17.1616 11.2085C17.6128 10.9559 17.6128 10.3243 17.1616 10.0717L15.3579 9.06177M4.68495 10.8829L2.83841 11.9167C2.3872 12.1693 2.3872 12.8009 2.83841 13.0536L10.4662 17.3242C10.885 17.5587 11.401 17.5587 11.8199 17.3242L17.1616 14.3335C17.6128 14.0809 17.6128 13.4493 17.1616 13.1967L15.3579 12.1868M17.1616 8.08338L11.8199 11.0741C11.401 11.3086 10.885 11.3086 10.4662 11.0741L2.83841 6.80345C2.3872 6.55082 2.3872 5.91924 2.83841 5.66662L8.18014 2.67587C8.59896 2.44138 9.11497 2.44138 9.5338 2.67587L17.1616 6.94655C17.6128 7.19918 17.6128 7.83076 17.1616 8.08338Z"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeMiterlimit="10"
      />
    </svg>
  )
}
